export {
  resolveSearchServiceUrl,
  EPHEMERAL_SEARCH_SANDBOX,
  SEARCH_SANDBOX_URLS,
  type SearchSandbox,
} from './search-sandbox'
